import React from 'react';
import useStyles,{getMuiTheme} from "./styles";
import {useTheme} from "@material-ui/core";
import { MuiThemeProvider } from "@material-ui/core/styles";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function FaIcon({icon="fas fa-cube",size="1x",color="",className=""}) {
  const classes = useStyles();
  const theme = useTheme();
  
  //const parseIcon = ()=>{
    let dataArr = icon?icon.toString().split(" "):[];
    dataArr = dataArr.filter((el,index)=>dataArr.indexOf(el)===index)
    //console.log("array",dataArr.length);
    if(dataArr.length===2){
      dataArr[1] = dataArr[1].replace("fa-","");
    }
    if(dataArr.length===3){
      //dataArr[0] = "";
      dataArr[1] = dataArr[2].replace("fa-","");
      dataArr.splice(2,1); 
    }
    
    //console.log("array",dataArr);
    //return dataArr;
  //}

  
  //parseIcon();
  return (
    <MuiThemeProvider theme={getMuiTheme(theme)}>      
      <FontAwesomeIcon icon={dataArr} size={size} color={color} className={className} />
    </MuiThemeProvider>
  );
}
